import { UseStore } from '@eastcoal/common/types/zustand'
import {
  useContextStore,
  useContextStoreApi
} from '@eastcoal/common/utils/zustand'

import { CrudModalFormStoreContext } from '../contexts/StoreContext'
import { CrudModalFormStore } from '../store/interface'

export const useCrudModalFormStore: UseStore<CrudModalFormStore> = selector => {
  return useContextStore(CrudModalFormStoreContext, selector)
}

export const useCrudModalFormStoreApi = () => {
  return useContextStoreApi(CrudModalFormStoreContext)
}
